module.exports = __webpack_public_path__ + "Assets/Images/qwilrPay/optional-payment-preview.svg";